<template>
  <div class="content">
    <div class="el-row">
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">ICCID：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.iccid}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">收货人姓名：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.name}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">收货人电话：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.phone}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">收货人地址：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.address}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">订单电话：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.orderPhone}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">补卡状态：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.status}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">创建时间：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.createTime}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">操作人：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.updateUser}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">补卡时间：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.updateTime}}</div>
        </div>
      </div>
    </div>
    <el-form ref="form" :model="form" :rules="rules" label-width="80px" class="form-class">
      <el-form-item label="快递公司" prop="outCompany">
        <el-input type="text" placeholder="请输入快递公司" v-model="form.outCompany" style="width:300px"/>
      </el-form-item>
      <el-form-item label="快递单号" prop="outNum">
        <el-input type="text" placeholder="请输入快递单号" autocomplete="off" v-model="form.outNum" style="width:300px"/>
      </el-form-item>
      <el-form-item label="新ICCID" prop="changeIccid">
        <el-input type="text" placeholder="请输入新ICCID" autocomplete="off" v-model="form.changeIccid" style="width:300px"/>
      </el-form-item>
    </el-form>
    <div class="left" style="padding-top:60px;padding-left: 80px;">
      <el-button type="primary" size="medium" @click="boot('form')" v-hasPermi="['card:change:edit']">提交数据</el-button>
    </div>
  </div>
</template>
<script>
import { getChangeDetail } from "@/api/api.js";//获取详情
import { updateCardChange } from "@/api/api.js";//提交补卡信息
export default {
  data() {
    return {
      id:'',
      data: {},
      form:{},
      rules: {
        outCompany: [
          { required: true, message: "快递公司不可为空", trigger: "blur" }
        ],
        outNum: [
          { required: true, message: "快递单号不可为空", trigger: "blur" }
        ],
        changeIccid:[
          { required: true, message: "新ICCID不可为空", trigger: "blur" }
        ]
      }
    };
  },
  computed: {},
  methods: {
    transferOrderStatus(status) {
      let obj = {
        1: "未发货",
        2: "已发货",
      };
      return obj[status];
    },
    // 初始化信息
    initData(){
      let params = {
        id:this.id
      }
      getChangeDetail(params).then(res => {
        this.data = res.data.data;
        this.form = res.data.data;
        this.data.status = this.transferOrderStatus(this.data.status);
      })
    },
    // 提交数据 
    boot(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            ...this.form
          };
          params.id = this.id;
          updateCardChange(params).then(res=>{
            this.$notify({
                title: '成功',
                message: '已补卡成功',
                type: 'success',
                offset:30
            });
          })
        }
      })
    }
  },
  created() {
    this.id =  this.$route.params && this.$route.params.id;
    this.initData();
  },
  mounted() {
    
  }
};
</script>
<style scoped>
.reg-img{
  max-width: 300px;
  max-height: 300px;
}
.el-form-item__content{
  color: #1890ff;
}
.form-class{
  margin-left: 50px;
  margin-top: 30px;
}
</style>
